module.exports = __webpack_public_path__ + "static/media/searchicon.5598343b.svg";